// File: src/common/enum/typeActiveStatusEnum.ts

/**
 * Este enum define os “códigos” (valores) que o backend espera para ativos e inativos.
 */
export enum TypeActiveStatus {
    NONE = '',
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
}

/**
 * Versão em português do enum, caso precise.
 */
export enum TypeActiveStatusBr {
    NONE = 'Todos',
    ACTIVE = 'Ativo',
    INACTIVE = 'Inativo',
}

/**
 * Mapeia cada valor do enum para o texto que o usuário verá na tela.
 */
export const TypeActiveStatusLabel: Record<TypeActiveStatus, string> = {
    [TypeActiveStatus.NONE]: 'Todos',
    [TypeActiveStatus.ACTIVE]: 'Ativo',
    [TypeActiveStatus.INACTIVE]: 'Inativo',
};

/**
 * Mapeia cada valor do enum para uma cor padrão a ser usada na UI.
 */
export const TypeActiveStatusColor: Record<TypeActiveStatus, string> = {
    [TypeActiveStatus.NONE]: '#808080',       // cinza (nenhum)
    [TypeActiveStatus.ACTIVE]: '#228B22',     // verde (ativo)
    [TypeActiveStatus.INACTIVE]: '#B22222',   // vermelho escuro (inativo)
};
